import React from "react";
import {Card} from "semantic-ui-react";
import {NumericFormat} from 'react-number-format';


export default function BalanceSum(props) {
        const {data, year, sum} = props
        let color = sum > 0 ? "green" : "red";

        return <Card>
            <Card.Content>
                <Card.Header>Jahres Summe DB</Card.Header>
                <Card.Meta>{year}</Card.Meta>
                <Card.Description>
                    <p style={{fontSize: "3em", margin: "1em 0", color: `${color}`,}}>
                        <NumericFormat value={sum}
                                       displayType={'text'}
                                       thousandSeparator={true}
                                       prefix={'€'}
                                       decimalScale={2}
                                       fixedDecimalScale={true}
                        />
                    </p>
                </Card.Description>
            </Card.Content>
        </Card>
}